module.exports = __webpack_public_path__ + "static/img/7.f5fa277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.png
// module id = 25
// module chunks = 0